import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomErrorHandler } from './core/interceptors/custom-error/custom-error-handler.interceptor';
import { HttpErrorInterceptor } from './core/interceptors/http-error/http-error.interceptor';
import { HttpHeaderInterceptor } from './core/interceptors/http-header/http-header.interceptor';
import { LoaderInterceptor } from './core/interceptors/loader/loader.interceptor';
import { AuthService } from './core/services/http/auth/auth.service';
import { MasterDataService } from './core/services/http/master-data/master-data.service';
import { PermissionsService } from './core/services/http/permissions/permissions.service';
import { UserService } from './core/services/user/user.service';
import { NotificationsModule } from './features/notifications/notifications/notifications.module';
import { LandingComponent } from './landing-page/landing.component';
import { PublicAccessComponent } from './public-access/public-access.component';
import { SharedModule } from './shared/shared.module';
import { appInitializer } from './shared/utils/app-initializer';
import { HttpLoaderFactory } from './shared/utils/http-loader-factory';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@NgModule({
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    MatMomentDateModule,
    MatSidenavModule,
    NotificationsModule,
    SharedModule,
    ToastModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
  ],
  declarations: [AppComponent, LandingComponent, PublicAccessComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      deps: [AuthService, UserService, MasterDataService, PermissionsService, MatDialog],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    MessageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
